import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseContainerService, BaseDataService, ModalContainerService, ModalService } from 'yt-ng-framework';
import { TreeviewItem } from 'ngx-treeview';
import { ConvItems2Treeviewitem } from 'src/app/core/classes/conv-items2-treeviewitem';
import { RadnoMesto } from './radno-mesto';

@Component({
  selector: 'yt-radno-mesto',
  templateUrl: './radno-mesto.component.html'
})
export class RadnoMestoComponent implements OnInit {
  list: TreeviewItem[];
  config={
    hasAllCheckBox: false,
    hasFilter: true,
    hasCollapseExpand: false,
    decoupleChildFromParent:true,
    maxHeight: 500
  };

  constructor(
    protected modalContainerServic: ModalContainerService<RadnoMesto>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected baseDataServce: BaseDataService,
    protected baseContainerService: BaseContainerService<RadnoMesto>,
    protected convItems2Tree: ConvItems2Treeviewitem
  ){}

  ngOnInit() {
  }

  OnMaindItemsLoaded(){}

}
